import { t } from "i18next";
import React, { useMemo, useState, useRef } from "react";
import { useTable, useSortBy, usePagination } from "react-table"; // Import useSortBy hook

import jsPDF from "jspdf";
import "jspdf-autotable";

import { useDownloadExcel } from "react-export-table-to-excel";
import { FaCheckDouble, FaFileExcel } from "react-icons/fa";

import jalaliMoment from "jalali-moment";
import toast from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom/dist";
import { InvoiceClearance } from "../../redux/InvoicesSection/InvoiceClearance";
import InlineLoadingAnimation from "../../shared/InlineLoadingAnimation";
import { BiSolidChevronLeft, BiSolidChevronRight, BiSolidChevronsLeft, BiSolidChevronsRight } from "react-icons/bi";
import { IoMdClose } from "react-icons/io";
import { MdSend } from "react-icons/md";
import Swal from "sweetalert2";
import PendingInvoiceRejectOption from "../traffic-control/PendingInvoiceRejectOption";

// import "jspdf-autotable/dist/polyfills.js";
// import "jspdf-autotable/dist/jspdf.plugin.autotable.js";

const InvoiceListTable = ({ carsData, recordType }) => {
  // console.log("Watin list called:");
  // console.log(carsData);
  const [filterValue, setFilterValue] = useState(""); // State variable for filtering
  const [selectedItems, setSelectedItems] = useState([]);
  const [checkBox, setCheckBox] = useState(true);
  const token = useSelector((state) => state.authentication.token);
  const user = useSelector((state) => state.authentication.user);
  const selected = useSelector((state) => state.invoice.selected);
  const loading = useSelector((state) => state.invoice.inlineLoading);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // console.log(carsData)

  const data = useMemo(() => {
    if (!carsData || !carsData.data) {
      return [];
    }

    // Apply filtering based on the filterValue
    return carsData.data.filter((row) => {
      return Object.values(row).some((value) =>
        value
          ? value.toString().toLowerCase().includes(filterValue.toLowerCase())
          : false
      );
    });
  }, [carsData, filterValue]);

  const columns = useMemo(
    () => [
      // {
      //   Header: t("vehicle_table.serial_number"),
      //   accessor: "id",
      // },
      {
        Header: t("vehicle_table.serial_number"),
        accessor: (row, index) => index + 1, // Generate sequential numbers
      },
      {
        Header: t("vehicle_table.driver_name"),
        accessor: "firstName",
      },
      {
        Header: t("vehicle_table.driver_father_name"),

        accessor: "fatherName",
      },

      {
        Header: t("vehicle_table.driver_nid"),
        accessor: "nid",
      },
      {
        Header: t("vehicle_table.province"),
        accessor: "province",
      },
      {
        Header: t("vehicle_table.date"),
        accessor: "per_date",
      },
      {
        Header: t("vehicle_table.car_type"),
        accessor: "carType",
      },
      {
        Header: t("vehicle_details_form.carNumPlat"),
        accessor: "carNumPlat",
        // Enable sorting for this column
        canSort: true,
      },
      {
        Header:  t("invoice.tarifaNumber"),
        accessor: "tNumber",
        // Enable sorting for this column
        canSort: true,
      },
      {
        Header:  t("invoice.price"),
        accessor: "price",
        // Enable sorting for this column
        canSort: true,
      },
      {
        Header: t("invoice.invoiceStatus"),
        accessor: "invoice_status",
        accessor: (row) =>
        row.invoice_status === "generated"
          ? t("invoice.generated")
          : row.invoice_status === "paid_invoice"
          ? t("vehicle_details_form.complated")
          : t("general_key_words.pending"),
      // row.workStatus==="registration" ? t("ثبت سیستم") : "رد شده"
      // Enable sorting for this column
      canSort: true,
        // Enable sorting for this column
        canSort: true,
      },
      {
        Header: t("vehicle_table.options_button"),
        id: "optionsButton", // Add a unique id for this column
      },
      {
        Header: t("general_key_words.choose"),
        id: "Check", // Add a unique id for this column
      },
      
      
    ],
    []
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    state: { pageIndex, pageSize },
    gotoPage,
    nextPage,
    previousPage,
    canNextPage,
    canPreviousPage,
    pageCount,
    setPageSize,
  } = useTable(
    {
      columns,
      data,
    },

    useSortBy, // Enable sorting
    usePagination
  );

  const totalPrice = useMemo(() => {
    if (!data || data.length === 0) {
      return 0;
    }
    return data.reduce((sum, row) => sum + parseInt(row.price, 10), 0);
  }, [data]);

  //downlaod excel sheet:
  const tableRef = useRef(null);
  const { onDownload } = useDownloadExcel({
    currentTableRef: tableRef.current,
    filename: t("excelTable.pendingInvoiceTable"),
    sheet: t("excelTable.pendingInvoiceSheet"),
  });

  //   const handleExportToExcel = () => {
  //     const exportData = page.map((row) => {
  //       const rowData = {};
  //       columns.forEach((column) => {
  //         // rowData[column.Header] = row.values[column.accessor];
  //         if (column.id !== "optionsButton") { // Exclude the "optionsButton" column
  //             rowData[column.Header] = row.values[column.accessor];
  //           }
  //       });
  //       return rowData;
  //     });
  //     onDownload(exportData, columns);
  //   };
  const handleExportToExcel = () => {
    const exportColumns = columns.filter(
      (column) => column.id !== "optionsButton"
    );
    const exportData = page.map((row) => {
      const rowData = {};
      exportColumns.forEach((column) => {
        rowData[column.Header] = row.values[column.accessor];
      });
      return rowData;
    });
    onDownload(exportData, exportColumns);
  };

  //download to pdf:
  const exportPDF = () => {
    // console.log("PDF");
    const unit = "pt";
    const size = "A4"; // Use A1, A2, A3, or A4
    const orientation = "portrait"; // portrait or landscape

    const marginLeft = 40;
    const doc = new jsPDF(orientation, unit, size);

    doc.setFontSize(15);

    const title = "Driver Table";
    const headers = [
      [
        t("Name"),
        t("Father Name"),
        t("NID"),
        t("Phone#"),
        t("Driving Permit"),
        t("Car Num Plat"),
        t("Province"),
      ],
    ];

    const data = page.map((row) => [
      row.original.firstName,
      row.original.fatherName,
      row.original.nid,
      row.original.phone,
      row.original.drivingPermit,
      row.original.carNumPlat,
      row.original.province,
    ]);

    doc.text(title, marginLeft, 40);
    doc.autoTable({
      startY: 50,
      head: headers,
      body: data,
    });

    doc.save("report.pdf");
  };
  const driverCheckHandler = (e, originalRow) => {
    const driverId = originalRow.dId;
    const invoiceId = originalRow.id;
  
    setSelectedItems((prevSelectedItems) => {
      const isSelected = prevSelectedItems.some(
        (item) => item.invoice_id === invoiceId
      );
  
      if (isSelected) {
        return prevSelectedItems.filter(
          (item) => item.invoice_id !== invoiceId
        );
      } else {
        return [
          ...prevSelectedItems,
          { driver_id: driverId, invoice_id: invoiceId },
        ];
      }
    });
  };
  // const driverCheckHandler = (e, originalRow) => {
  //   // const id = e.target.id;
  //   // const driverId = originalRow.driver.id;
  //   const driverId = originalRow.dId;
  //   const invoiceId = originalRow.id;

  //   setSelectedItems((prevSelectedItems) => {
  //     const isSelected = prevSelectedItems.some(
  //       (item) => item.id === invoiceId
  //     );

  //     if (isSelected) {
  //       return prevSelectedItems.filter((item) => item.id !== invoiceId);
  //     } else {
  //       return [
  //         ...prevSelectedItems,
  //         { driver_id: driverId, invoice_id: invoiceId },
  //       ];
  //     }
  //   });
  // };

  const handleCheckBoxActivate = (e) => {
    setCheckBox(!checkBox);
    setSelectedItems([]);
  };

  const handleTransfer = () => {
    if (selectedItems.length > 0) {
      Swal.fire({
        title: t("general_key_words.areYouSure"),
        text: t("general_key_words.confirmChangeMsg"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: t("general_key_words.yesGenerateIvoice"),
        cancelButtonText: t("general_key_words.cancel"),
      }).then((result) => {
        if (result.isConfirmed) {
          dispatch(InvoiceClearance(token, selectedItems));
          handleCheckBoxActivate();
      // console.log(selectedItems)
        }
      });

      // dispatch(InvoiceClearance(token, selectedItems));
      // console.log(selectedItems)
    } else toast.error(t("general_key_words.noRecordSelect"));
    setSelectedItems([]);
  };

  return (
    <div>
      {/* Input field for filtering */}
      {/* <input
        type="text"
        className="form-control m-0 rounded-3"
        value={filterValue}
        onChange={(e) => setFilterValue(e.target.value)}
        placeholder={t("general_key_words.search")}
      /> */}

      <div className="row mt-2 mb-2">
        <div className="col-sm-12 col-md-8">
          <input
            type="text"
            className="form-control"
            value={filterValue}
            onChange={(e) => setFilterValue(e.target.value)}
            placeholder={t("general_key_words.search")}
          />
        </div>
        <div className="col-sm-12 col-md-4">
          <div className="bg-white rounded-2 mt-2 mt-lg-0 mb-0 d-flex flex-row align-items-center justify-content-between">
            <div onClick={handleExportToExcel}>
              <FaFileExcel
                style={{ color: "green", cursor: "pointer", fontSize: "25px" }}
              />
            </div>
            <div className="d-flex flex-row align-items-center">
              <span className="mx-2">{t("general_key_words.show")}</span>
              <select
                value={pageSize}
                className="form-select"
                onChange={(e) => {
                  setPageSize(Number(e.target.value));
                }}
              >
                {[5, 10, 20, 50, 100, 200, 400, 800, 1600].map((pageSize) => (
                  <option key={pageSize} value={pageSize}>
                    {pageSize}
                  </option>
                ))}
              </select>
            </div>
            <div className="mx-1 d-flex flex-row gap-1">
              <button
                className={`btn ${
                  checkBox ? "btn-secondary" : "btn-danger"
                }`}
                onClick={handleCheckBoxActivate}
              >
                {checkBox
                  ? <FaCheckDouble />
                  : <IoMdClose />
                }
              </button>
              {!checkBox && (
                <button
                  className={`btn btn-success d-flex gap-1 align-items-center`}
                  onClick={handleTransfer}
                >
                  {t("general_key_words.generateInvice")}
                  <MdSend className="bi"/>
                </button>
              )}
            </div>
          </div>
        </div>
      </div>

      <table
        className="table table-hover"
        id="property-table"
        // ref={tableRef}
        {...getTableProps()}
        border="1"
      >
        <thead>
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()} key="header" className="text-center">
              {headerGroup.headers.map((column) => (
                <th {...column.getHeaderProps(column.getSortByToggleProps())}
                className="table-header-style"
                >
                  {column.render("Header")}
                  {/* Display sorting indicators */}
                  <span>
                    {column.isSorted
                      ? column.isSortedDesc
                        ? " 🔽"
                        : " 🔼"
                      : ""}
                  </span>
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {page.map((row) => {
            prepareRow(row);
            return (
              <tr {...row.getRowProps()} key={row.original.id} className="text-center">
                {row.cells.map((cell, index) => {
                  //   return <td {...cell.getCellProps()}>{cell.render("Cell")}</td>;
                  return (
                    <td {...cell.getCellProps()}
                    className="table-cells-style"
                    >
                      {index === row.cells.length - 1 ? (
                        loading ?
                   
                         (
                          <InlineLoadingAnimation />
                        ) : (
                          <input
                            type="checkbox"
                            className="form-check-input"
                            disabled={checkBox}
                            id={row.original.id}
                            onChange={(e) => driverCheckHandler(e, row.original)}
                            checked={selectedItems.some((item) => item.invoice_id === row.original.id)}
                          />
                        )
                      ): index === row.cells.length - 2 ? (
                        <PendingInvoiceRejectOption
                          record={row.original}
                          section={"driver"}
                          user = {user}
                        />
                      )
                      : cell.column.id === "per_date" ? (
                        // Assuming your date is in the format YYYY-MM-DD
                        // Adjust format as needed
                        jalaliMoment(cell.value)
                          .locale("fa")
                          .format("YYYY-MM-DD")
                      ) : (
                        cell.render("Cell")
                      )}
                    </td>
                  );
                })}
              </tr>
            );
          })}
          {/* Add a new row to display the total price */}
          <tr >
            <td className="text-center fw-bold" colSpan={columns.length}>{t("invoice.totalPrice")}: {totalPrice} (AF)</td>
          </tr>
        </tbody>
      </table>

      {/* Table for excel exporting: */}
      <table
        className="table d-none table-hover"
        id="property-table"
        ref={tableRef}
        {...getTableProps()}
        border="1"
      >
        <caption style={{ textAlign: "center", fontSize: "20px", fontWeight: "bold" }}>
            <br/>
            {t("message.brand")} <br /> {recordType}
            ({jalaliMoment(new Date().toDateString()).locale("fa").format("DD-MM-YYYY")})
        </caption>
        <thead>
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()} key="header" className="text-center">
              {headerGroup.headers.map((column) => (
                <th {...column.getHeaderProps(column.getSortByToggleProps())}
                className="table-header-style"
                >
                  {column.render("Header")}
                  {/* Display sorting indicators */}
                  <span>
                    {column.isSorted
                      ? column.isSortedDesc
                        ? " 🔽"
                        : " 🔼"
                      : ""}
                  </span>
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {page.map((row) => {
            prepareRow(row);
            return (
              <tr {...row.getRowProps()} key={row.original.id} className="text-center">
                {row.cells.map((cell, index) => {
                  //   return <td {...cell.getCellProps()}>{cell.render("Cell")}</td>;
                  return (
                    <td {...cell.getCellProps()}
                    className="table-cells-style"
                    >
                      {index === row.cells.length - 1 ? (
                        loading ?
                   
                         (
                          <InlineLoadingAnimation />
                        ) : (
                          null
                        )
                      ) : cell.column.id === "gre_date" ? (
                        // Assuming your date is in the format YYYY-MM-DD
                        // Adjust format as needed
                        jalaliMoment(cell.value)
                          .locale("fa")
                          .format("YYYY-MM-DD")
                      ) : (
                        cell.render("Cell")
                      )}
                    </td>
                  );
                })}
              </tr>
            );
          })}
          {/* Add a new row to display the total price */}
          <tr className="text-center">
            <td className="text-center fw-bold" colSpan={columns.length-1}>{t("invoice.totalPrice")}: {totalPrice} (AF)</td>
          </tr>
        </tbody>
      </table>
      
      <div>
      {pageCount > 1 && (
        <ul className="pagination bg-white py-2 rounded-3 d-flex flex-row justify-content-between px-2 mt-2">
          <li className="page-item ">
            <button className="btn btn-light p-0 p-1" disabled>
              {t("general_key_words.page")}{" "}
              <strong>
                {pageIndex + 1} / {pageCount}
              </strong>{" "}
            </button>
          </li>
          <div className="d-flex flex-row gap-1">
            <li className="page-item ">
              <button
                className="btn btn-primary py-2 d-flex align-items-center"
                onClick={() => gotoPage(0)}
                disabled={!canPreviousPage}
              >
                <BiSolidChevronsLeft className="fs-6" />
              </button>
            </li>
            <li className="page-item ">
              <button
                className="btn btn-primary p-1 px-2 d-flex align-items-center"
                onClick={() => previousPage()}
                disabled={!canPreviousPage}
              >
                <BiSolidChevronLeft className="fs-6 bi" />
                <span className="fs-6">{t("general_key_words.previous")}</span>
              </button>
            </li>
            <li className="page-item ">
              <button
                className="btn btn-primary p-1 px-2 d-flex align-items-center"
                onClick={() => nextPage()}
                disabled={!canNextPage}
              >
                <BiSolidChevronRight className="fs-6 bi" />
                <span className="fs-6">{t("general_key_words.next")}</span>
              </button>
            </li>
            <li className="page-item ">
              <button
                className="btn btn-primary py-2 d-flex align-items-center"
                onClick={() => gotoPage(pageCount - 1)}
                disabled={!canNextPage}
              >
                <BiSolidChevronsRight className="fs-6" />
              </button>
            </li>
          </div>
        </ul>
      )}
      </div>
    </div>
  );
};

export default InvoiceListTable;
